import Services from "../../services";

class PengakuanHutangApi {
  // API SERVER
  get(params) {
    return Services.get("approval_pengeluaran/list", { params });
  }

  getHistory(params) {
    return Services.get("approval_pengeluaran/history/list", { params });
  }

  getSingle(params) {
    return Services.get("approval_pengeluaran/detail", { params });
  }

  approve(data) {
    return Services.post("approval_pengeluaran/approve", data);
  }
}

export default new PengakuanHutangApi();
